import React from 'react'
import InputFieldUI from './InputFieldUI'
import PhoneNumberUI from '../input/PhoneNumberUI'
import './InputPhoneNumber.css'

const InputPhoneNumberUI = ({context, name, value, onChange,
    // label
    label, help, messageList, labelKey, helpKey,
    // behavior
    required, autoFocus, disabled, error}) =>
  <InputFieldUI className='w_input_ph' name={name} required={required}
    label={label} help={help} messageList={messageList} labelKey={labelKey} helpKey={helpKey}>
    <PhoneNumberUI name={name} value={value} onChange={onChange}
      autoFocus={autoFocus} disabled={disabled}
      className={error ? 'hasError' : ''}
    />
  </InputFieldUI>

export default InputPhoneNumberUI
